import { getMobGoldValue } from "../economy/mobGoldValues";
import { RobotActorState, type MusicOverrider } from "../interfaces";
import { MusicId } from "../musicId";
import { STD_BASE_HP } from "../physicalThingWithHp";
import { deserializeXY } from "../serialization";
import { PlowRobot } from "./plowRobot";
import type { XY } from "../xy";
import type { Board } from "../board.ts";
import { Gas } from "../things/gas.ts";
import { ParticleEffect } from "../effects/particleEffect.ts";
import { ParticleType } from "../particleType.ts";
import { Sound } from "../things/sounds/sound.ts";
import { SoundId } from "../things/sounds/soundId.ts";

export class BossPlowRobot extends PlowRobot implements MusicOverrider {
	static override key = "BossPlowRobot";

	constructor(xy: XY, state: RobotActorState = RobotActorState.OFF) {
		super(xy, state);
		this.hp = STD_BASE_HP * 20;
		this.maxHp = STD_BASE_HP * 20;
		// this.ai.pathfindCostSwitchToHeuristic = 3.0;
		this.ai.alwaysKnowsWhereTargetIs = true;
		this.ai.probabilityToBreakBlockWhenStuck = 1;
		this.ai.probabilityToActWhenNotIdle = 0.7;
		this.ai.noiseProbability = 0.4;
		this.ai.minimumDistanceToNoise = 40;
		this.ai.noiseCoolDown = 5;
	}

	processMobAction(board: Board) {
		const previousXY = this.xy;
		super.processMobAction(board);
		const didIMove = !previousXY.equals(this.xy);
		if (this.getState() === RobotActorState.ATTACKING && !didIMove) {
			const releasedAmount = 20;
			const existingGas = board.getThingOfClass(Gas, this.xy!);
			if (existingGas !== null) {
				existingGas.setCompression(existingGas.getCompression() + releasedAmount);
			} else {
				const gas = new Gas(this.xy!, releasedAmount);
				board.addThing(gas);
			}
			board.addEffect(new ParticleEffect(this.xy!, ParticleType.TOXIC_GAS_BURST, 25));
			board.addNonPhysicalThing(new Sound(SoundId.GAS_RELEASE_BOSS, this.xy!));
		}
	}

	override getAttackDamage(): number {
		return Math.floor(STD_BASE_HP * 2.5);
	}

	override getBaseGoldValue(): number {
		return getMobGoldValue(BossPlowRobot.key);
	}

	getMusicOverride(): MusicId | null {
		return this.getState() === RobotActorState.OFF ? null : MusicId.BOSS_PLOW;
	}

	static override deserialize(data: any): BossPlowRobot {
		const m = new BossPlowRobot(deserializeXY(data.xy), data.state);
		m.restoreMobFields(data);
		m.ai.restoreFrom(data.ai);
		return m;
	}
}
